import { createAction } from 'redux-actions'
import Api from '../Api'

import { SAVE_RIDER } from './rider'

export const ADD_RIDER_COLUMN = createAction('ADD_RIDER_COLUMN', column => column)
export const REMOVE_RIDER_COLUMN = createAction('REMOVE_RIDER_COLUMN', index => index)
export const CREATE_RIDER_COLUMN = createAction('CREATE_RIDER_COLUMN', column => column)
export const MOVE_RIDER_COLUMN = createAction('MOVE_RIDER_COLUMN', column => column)
export const DELETE_RIDER_COLUMN = createAction('DELETE_RIDER_COLUMN', column => column)

export const addRiderColumn = (column = {}) => {
  return (dispatch) => dispatch(ADD_RIDER_COLUMN({column}))
}

export const removeRiderColumn = (index) => {
  return (dispatch) => dispatch(REMOVE_RIDER_COLUMN({index}))
}

export const createRiderColumn = (riderId, column) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(CREATE_RIDER_COLUMN(Api.createRiderColumn(riderId, column)))
  }
}

export const moveRiderColumn = (column) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(MOVE_RIDER_COLUMN(Api.moveRiderColumn(column)))
  }
}

export const deleteRiderColumn = (id) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(DELETE_RIDER_COLUMN(Api.deleteRiderColumn(id)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider-column.js